import React, { Fragment } from "react";
import { Alert, Link, Table, TableBody, TableContainer, TableHead } from "@mui/material";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { isArrayEmpty, isArrayNotEmpty, TableButton } from "@duosoftbg/nacid-components";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { buildFetchFileUrl } from "../../../../../axios/api/services";
import { openModal } from "../../../../../store/redux/slice/ComponentsControl/lawControl";
import useAppDispatch from "../../../../../hooks/redux/base/useAppDispatch";

const LawFilesButtonTableCell = styled(TableCell)`
  text-align: right;
  width: 80px;
`;

export const LawpEmptyListAlert = styled(Alert)`
  padding-top: 1px;
  padding-bottom: 1px;
  background: white;
  border: 1px solid #d8d8d8;
  border-top: 0px;
`;

const LawFormFiles = ({ files }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  return (
    <Fragment>
      <TableContainer>
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow>
              <TableCell style={{ width: 35 }}>{t("l.table.head.number")}</TableCell>
              <TableCell>{t("l.table.head.file")}</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          {isArrayNotEmpty(files) && (
            <TableBody>
              {files.map((file, index) => (
                <TableRow key={file.fileId}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>
                    <Link download href={buildFetchFileUrl(file.relativePath, file.fileId, file.rootDirectory)}>
                      {file.fileName}
                    </Link>
                  </TableCell>
                  <LawFilesButtonTableCell>
                    <TableButton
                      type={"delete"}
                      onClick={() => {
                        const payload = { id: file.fileId, modalType: "delete" };
                        dispatch(openModal(payload));
                      }}
                    />
                  </LawFilesButtonTableCell>
                </TableRow>
              ))}
            </TableBody>
          )}
        </Table>
        {isArrayEmpty(files) && <LawpEmptyListAlert severity="info">{t("m.empty.list")}</LawpEmptyListAlert>}
      </TableContainer>
    </Fragment>
  );
};

export default LawFormFiles;
